import React, { useState } from 'react'
import '../assets/css/challange.scss'
import PlayerCard from '../components/Challange/PlayerCard'
import PlayerProfile from '../components/Challange/PlayerProfile'
import Ads1 from "../assets/images/TodayPrizeScreen/today_prize_1.svg"

import Header from '../components/Header'
import Footer from '../components/Footer'

import sampleImg1 from '../assets/images/PlayerScreen/myPic.jpg'
import sampleImg2 from '../assets/images/PlayerScreen/myPic1.png'
import pak from '../assets/images/PlayerScreen/pak.png'
import dia from '../assets/images/PlayerScreen/dia.png'
import crown from '../assets/images/PlayerScreen/crown.svg'
import FrameCongra from '../assets/images/PlayerWaiting/FrameCongra.png'
import '../assets/css/style.scss'
import Congra from '../components/Challange/Congra'
import Category from '../components/Challange/Category'
import Qauestions from '../components/Challange/Qauestions'

export default function () {

const [nextNav, setNextNav] = useState(0)

  const updateNextNave=()=>{
    setNextNav(nextNav+1)
  }



  return (
    <div className='challange ' style={{height:"100vh", overflow:"hidden"}}>
      <div className="mx-3"> <Header /></div>
      <div className='row px-2 '    style={{height:"75vh"}} >

<div className="col-3 " >

<div className="row " style={{height:"100%"}} >

<div className="col-12 " style={{height:"10%"}}>


<div className=" my-0 " >

<div className="player-screen-body-border"  >

  <div className="row ">

    <div className="col-3  position-relative ">
      <img className='player-screen-card-profile m-1' src={sampleImg2} alt="" />

      <div className='position-absolute player-screen-card-crown pr-1'>
        <img className='challange-crown'  src={crown} alt="" />
      </div>

    </div>

    <div className="col-3 px-0">

      <div className='challange-card-div1  '>

        <img player-screen-card-img1 src={pak} alt="" /> <span className='challange-card-text1 text-light'>Hafiz F</span>

      </div>

      <div className='challange-card-div2'>

        <img player-screen-card-img2 src={dia} alt="" />  <span className='challange-card-text2 text-light'>Hafiz F1</span>

      </div>


    </div>

    <div className="col-6 px-0 ">
    <i class="fa-solid fa-star " style={{color:"#F24382", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    </div>

  </div>

</div>

</div>


{/* <div className="col-12 mb-2 mt-1 ">

                                        <div className="player-screen-body-border" >

                                            <div className="row ">

                                                <div className="col-3 position-relative ">
                                                    <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                                                    <div className='position-absolute player-waiting-card-crown'>
                                                        <img src={crown} alt="" />
                                                    </div>

                                                </div>

                                                <div className="col-9 ">

                                                    <div className='player-waiting-card-div1 '>

                                                        <img src={pak} alt="" /> <span className='player-waiting-card-text1 text-light '>asdas</span>

                                                    </div>

                                                    <div className='player-waiting-card-div2 '>

                                                        <img src={dia} alt="" />  <span className='player-waiting-card-text2 text-light '>asd</span>

                                                    </div>


                                                </div>

                                            </div>

                                        </div>

                                    </div> */}

</div>

<div className="col-12 py-4  d-flex justify-content-center align-items-center" style={{ height:"40%"}}>

<img  style={{width:"12vw", height:"12vw", borderRadius:"50%", border:"2px solid #30AEBA"}} src={sampleImg2} alt="" />
  
</div>

<div className="col-12 d-flex justify-content-center mt-3"  style={{ height:"60%"}}>

<img style={{width:"17vw", height:"17vw"}} src={FrameCongra} alt="" />

</div>

</div>

</div>

        {/* <div className='col-3'>
          <PlayerCard />
          <div className='d-flex justify-content-center mt-4'>
            <PlayerProfile />
          </div>
          <div className='d-flex justify-content-center mt-4'>
            <img src={Ads1} />
          </div>
        </div> */}


<div className="col-6 challange-congra-background"  style={{height:"100%"}}>

{/* Center Components  */}

{/* <Congra/> */}

{/* <Category/> */}

{
  nextNav ===0 && <Category/>    
}

{
   nextNav ===1 && <Qauestions/>  
}

{
   nextNav ===2 && <Congra />  
}

{
   nextNav ===3 && <Congra nextNav={nextNav} />  
}

{
  nextNav>3 && setNextNav(3) 
}


</div>



        {/* <div className='col-6 position-relative challange-center'>
          <div className='mt-4 challange-center-head'>Congratulations</div>
          <div className='row d-flex mt-4 justify-content-center'>
            <div>
            <PlayerCard />

            </div>
          </div>
        </div> */}


<div className="col-3 " >

<div className="row " style={{height:"100%"}} >

<div className="col-12 " style={{height:"10%"}}>


<div className=" my-0 " >

<div className="player-screen-body-border"  >

  <div className="row ">

    <div className="col-3  position-relative ">
      <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

      <div className='position-absolute player-screen-card-crown pr-1'>
        <img className='challange-crown'  src={crown} alt="" />
      </div>

    </div>

    <div className="col-3 px-0">

      <div className='challange-card-div1  '>

        <img player-screen-card-img1 src={pak} alt="" /> <span className='challange-card-text1 text-light'>Hafiz F</span>

      </div>

      <div className='challange-card-div2'>

        <img player-screen-card-img2 src={dia} alt="" />  <span className='challange-card-text2 text-light'>Hafiz F1</span>

      </div>


    </div>

    <div className="col-6 px-0 ">
    <i class="fa-solid fa-star " style={{color:"green", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    <i class="fa-solid fa-star " style={{color:"#A6A6A6", width:"2%", height:"2%", marginRight:"13%", marginTop:"8%"}}></i>
    </div>

  </div>

</div>

</div>


{/* <div className="col-12 mb-2 mt-1 ">

                                        <div className="player-screen-body-border" >

                                            <div className="row ">

                                                <div className="col-3 position-relative ">
                                                    <img className='player-screen-card-profile m-1' src={sampleImg1} alt="" />

                                                    <div className='position-absolute player-waiting-card-crown'>
                                                        <img src={crown} alt="" />
                                                    </div>

                                                </div>

                                                <div className="col-9 ">

                                                    <div className='player-waiting-card-div1 '>

                                                        <img src={pak} alt="" /> <span className='player-waiting-card-text1 text-light '>asdas</span>

                                                    </div>

                                                    <div className='player-waiting-card-div2 '>

                                                        <img src={dia} alt="" />  <span className='player-waiting-card-text2 text-light '>asd</span>

                                                    </div>


                                                </div>

                                            </div>

                                        </div>

                                    </div> */}

</div>

<div className="col-12 py-4  d-flex justify-content-center align-items-center" style={{ height:"40%"}}>

<img  style={{width:"12vw", height:"12vw", borderRadius:"50%", border:"2px solid #30AEBA"}} src={sampleImg1} alt="" />
  
</div>

<div className="col-12 d-flex justify-content-center mt-3"  style={{ height:"60%"}}>

<img style={{width:"17vw", height:"17vw"}} src={FrameCongra} alt="" />

</div>

</div>

</div>


        {/* <div className='col-3'>
          <PlayerCard />
          <div className='d-flex justify-content-center mt-4'>
            <PlayerProfile />
          </div>
          <div className='d-flex justify-content-center mt-4'>
            <img src={Ads1} />
          </div>
        </div> */}

      </div>
      <div className='col-12' style={{position:"fixed", bottom:"0", backgroundColor:"black"}}>

      <Footer BackPage="/leaderboard" setNextNav={updateNextNave}  />

    </div>

    </div>
  )
}
